export enum OrganizationModals {
  DELETE_ORGANIZATION = 'DELETE_ORGANIZATION',
  CONFIRMATION_DELETE_ORGANIZATION = 'CONFIRMATION_DELETE_ORGANIZATION',
}
